import { styled } from '@mui/material/styles';

export const Button = styled('button', {
  shouldForwardProp: prop => !['$color', '$size', '$variant'].includes(prop)
})(({ theme, $color = 'default', $variant = 'text' }) => {
  const colorObj = theme.color[$color] || theme.color.default;
  const disabledSelector = '&:disabled, &[disabled], &[aria-disabled="true"], &[data-disabled="true"]';
  const disabledCursorStyles = {
    cursor: 'default !important',
    pointerEvents: 'none'
  };
  
  const getColorStyles = () => {
    if ($color === 'default') {
      return {
        '&, &:visited': {
          color: colorObj.main
        },
        '&:hover': {
          color: theme.color.primary.main
        },
        '&:active': {
          background: theme.color.primary.main,
          borderColor: theme.color.primary.main,
          color: theme.color.primary.contrast
        },
        [disabledSelector]: {
          ...disabledCursorStyles,
          background: 'none',
          borderColor: 'transparent',
          color: theme.color.disabled.text,
          '&:hover, &:active': {
            background: 'none',
            borderColor: 'transparent',
            color: theme.color.disabled.text
          }
        }
      };
    }

    if ($variant === 'text') {
      return {
        '&, &:visited': {
          color: colorObj.main
        },
        '&:hover': {
          borderColor: colorObj.main
        },
        '&:active': {
          background: colorObj.main,
          borderColor: colorObj.main,
          color: colorObj.contrast
        },
        [disabledSelector]: {
          ...disabledCursorStyles,
          background: 'none',
          borderColor: 'transparent',
          color: theme.color.disabled.text,
          '&:hover, &:active': {
            background: 'none',
            borderColor: 'transparent',
            color: theme.color.disabled.text
          }
        }
      };
    }

    if ($variant === 'lightText') {
      return {
        '&, &:visited': {
          color: colorObj.contrast
        },
        '&:hover': {
          borderColor: colorObj.contrast
        },
        '&:active': {
          background: colorObj.contrast,
          borderColor: colorObj.contrast,
          color: colorObj.main
        },
        [disabledSelector]: {
          ...disabledCursorStyles,
          background: 'none',
          borderColor: 'transparent',
          color: theme.color.disabled.text,
          '&:hover, &:active': {
            background: 'none',
            borderColor: 'transparent',
            color: theme.color.disabled.text
          }
        }
      };
    }

    return {};
  };

  return {
    alignItems: 'center',
    background: 'none',
    borderRadius: theme.borderRadius.base,
    border: '1px solid transparent',
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
    transition: `all ${theme.animation.standard}`,
    ...getColorStyles(),
    '&&': {
      WebkitAppearance: 'none'
    }
  };
});
